import type { EmployeeReportCategory, EmployeeReportSeverity, EmployeeReportStatus } from '@/types';

export const CATEGORY_LABELS: Record<EmployeeReportCategory, string> = {
    fraud: 'Fraud',
    theft: 'Theft',
    financial_misconduct: 'Financial misconduct',
    falsification: 'Falsification',
    absconding: 'Absconding',
    violence: 'Violence',
    harassment: 'Harassment',
    gross_misconduct: 'Gross misconduct',
    other: 'Other',
};

export const CATEGORY_OPTIONS: { value: EmployeeReportCategory; label: string }[] = (
    Object.keys(CATEGORY_LABELS) as EmployeeReportCategory[]
).map((value) => ({ value, label: CATEGORY_LABELS[value] }));

export const SEVERITY_LABELS: Record<EmployeeReportSeverity, string> = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
};

export const SEVERITY_OPTIONS: { value: EmployeeReportSeverity; label: string }[] = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
];

// Tailwind pill classes per severity.
export const SEVERITY_PILL: Record<EmployeeReportSeverity, string> = {
    low: 'bg-gray-100 text-gray-700 border-gray-200',
    medium: 'bg-amber-50 text-amber-700 border-amber-200',
    high: 'bg-red-50 text-red-700 border-red-200',
};

export const STATUS_LABELS: Record<EmployeeReportStatus, string> = {
    active: 'Active',
    dismissed: 'Dismissed',
};

export const STATUS_PILL: Record<EmployeeReportStatus, string> = {
    active: 'bg-green-50 text-green-700 border-green-200',
    dismissed: 'bg-gray-100 text-gray-600 border-gray-200',
};

// Human label for a matched identifier from a scan result.
const MATCH_LABELS: Record<string, string> = {
    nin: 'NIN',
    email: 'email',
    phone: 'phone',
    name: 'name',
};

export function matchLabel(key: string): string {
    return MATCH_LABELS[key] ?? key;
}

// NIN / email / phone are unique identifiers → a strong match. A name-only match
// is weak (people share names), so the UI should flag it as needs-review.
const STRONG_IDENTIFIERS = new Set(['nin', 'email', 'phone']);

export function matchStrength(matchedOn: string[] | undefined): 'strong' | 'weak' {
    if (matchedOn?.some((m) => STRONG_IDENTIFIERS.has(m))) return 'strong';
    return 'weak';
}
